import { Layout } from 'antd';
import React from 'react';
import styled from '@emotion/styled';
import { CSSProperties } from 'react';
import isPropValid from '@emotion/is-prop-valid';

type FullLayoutProps = {
  header?: React.ReactElement;
  footer?: React.ReactElement;
  children: React.ReactElement;
  className?: any;
  $alignItems?: string;
};
const StyledLayout = styled(Layout, {
  shouldForwardProp: (prop) => isPropValid(prop)
})`
  min-height: 100vh;
  overflow: auto;
  width: 100%;
  .ant-layout-content {
    display: flex;
    width: 100%;
    flex-grow: 1;
  }
`;

const StyledHeader = styled(Layout.Header)`
  position: sticky;
  top: 0;
  z-index: 100;
`;
export const FullLayout = (
  props: Partial<FullLayoutProps & Partial<Pick<CSSProperties, 'alignItems'>>>
) => {
  const { header, footer, className, ...rest } = props;
  return (
    <StyledLayout className={className} {...rest}>
      {header && <StyledHeader>{header}</StyledHeader>}
      <Layout.Content>{props.children}</Layout.Content>
      {footer && <Layout.Footer>{footer}</Layout.Footer>}
    </StyledLayout>
  );
};
